import '../head-doctor/HeadDoctorDashboard.css';
import NursingPortalLayout from '../nurse/NursingPortalLayout';

export default function MajorLayout() {
  return <NursingPortalLayout variant="major" />;
}
